import { useTranslation } from 'react-i18next'
import { ReactSVG } from 'react-svg'

import ReceiptsModal from '@entities/Order/ui/ReceiptsModal/ReceiptsModal'

import { useModalStore } from '@features/modal'

import { OrdersEdge } from '@shared/generated'

import styles from './styles.module.scss'



export default function OrderFooter ({
  data,
}: {
  data: NonNullable<NonNullable<OrdersEdge['edges']>[number]>;
}) {
  const { t: to } = useTranslation('order')
  const { openModal } = useModalStore()

  return (
    <div className={styles.footer}>
      {/* <Button size={isMobile ? "small" : "large"} theme="secondary">
        <ReactSVG src="/icons/repeat.svg" wrapper="span" />
        {to("order.button.reset")}
      </Button> */}
      {data?.receipts && data?.receipts?.length > 0 && (
        <div
          onClick={() => {
            openModal('receipts', <ReceiptsModal data={data} />, {
              title: to('order.button.receipt'),
            })
          }}
          className={styles.footer__receipt}
        >
          <ReactSVG src="/icons/receipt.svg" />
          <span> {to('order.button.receipt')}</span>
        </div>
      )}
    </div>
  )
}
